<template>
  <v-card hover class="ma-1 my-2 task-card beez-card">
    <v-toolbar flat dense>
      <v-chip
        outline
        :color="task.taskType === 'APPROVAL_TASK' ? 'secondary' : 'accent'"
      >
        <span>
          {{
            task.taskType === 'APPROVAL_TASK'
              ? 'Approval Task'
              : 'User Input task'
          }}</span
        >
      </v-chip>
      <v-spacer></v-spacer>
      <task-comments :task-hex-id="task.hexId" />
    </v-toolbar>
    <v-card-text>
      <v-layout
        @click="expandItem = !expandItem"
        align-center
        justify-space-between
        row
        wrap
        fill-height
      >
        <v-flex xs12 sm12 md2>
          <v-flex xs12>
            <div style="font-size: 1.0em;" align="left">
              <div>
                {{ task.name || task.formKey }}
              </div>
              <v-chip v-if="task.inProgress" color="accent" outline
                ><span>In Progress</span>
              </v-chip>
              <v-flex class="mt-3" v-if="task.assignee">
                <div class="mt-2" style="font-size: 0.8em;" align="left">
                  <div class="beez-bold">Assigned To</div>
                  <span>{{ task.assignee }}</span>
                </div>
              </v-flex>
              <v-flex v-if="task.externalRequestedBy">
                <div class="mt-2" style="font-size: 0.8em;" align="left">
                  <div class="beez-bold">Requested By</div>
                  <span>{{ task.externalRequestedBy }}</span>
                </div>
              </v-flex>
            </div>
          </v-flex>
        </v-flex>
        <v-flex xs12 sm12 md2>
          <v-layout column>
            <v-flex>
              <div align="left">
                <div class="beez-bold">Created At</div>
                <span>{{ convertDate(task.createdAt) }}</span>
              </div>
            </v-flex>
            <v-flex>
              <div align="left">
                <div class="beez-bold">Due Date</div>
                <span>{{ convertDate(task.due) }}</span>
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 sm12 md6>
          <task-dimensions-and-metrics :task="task" />
        </v-flex>
        <v-flex xs12 sm12 md2>
          <v-layout column>
            <v-flex>
              <div align="center">
                <div>
                  Status
                </div>
              </div>
              <div>
                <span
                  v-if="task.status === 'assignment'"
                  style="font-weight: 500"
                  class="pr-2 primary--text"
                  >Assigned</span
                >
                <span
                  v-else-if="task.status === 'create'"
                  style="font-weight: 500"
                  class="pr-2 primary--text"
                  >Open</span
                >
                <span
                  v-else-if="task.status === 'delete'"
                  style="font-weight: 500"
                  class="pr-2 primary--text"
                  >Deleted</span
                >
                <span
                  v-else-if="task.status === 'complete'"
                  style="font-weight: 500"
                  class="pr-2 primary--text"
                  >Completed</span
                >
                <span
                  v-else
                  style="font-weight: 500"
                  class="pr-2 primary--text"
                  >{{ task.status }}</span
                >
              </div>
            </v-flex>
            <v-flex>
              <div style="font-size: 1.0em;" align="center">
                <div>
                  Approval Status
                </div>
              </div>
              <div>
                <span
                  v-if="task.approvalStatus === null"
                  style="font-weight: 500"
                  class="pr-2 blue--text"
                  >Open</span
                >
                <span
                  v-else-if="task.approvalStatus === true"
                  style="font-weight: 500"
                  class="pr-2 green--text"
                  >Approved</span
                >
                <span
                  v-else-if="task.approvalStatus === false"
                  style="font-weight: 500"
                  class="pr-2 red--text"
                  >Rejected</span
                >
                <span v-else style="font-weight: 500" class="pr-2">
                  {{ task.approvalStatus }}
                </span>
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>

      <v-expand-transition>
        <task-detail v-if="expandItem" :task-id="task.hexId"></task-detail>
      </v-expand-transition>
    </v-card-text>
  </v-card>
</template>

<script>
import TaskComments from '@/components/task-lists/TaskComments'
import TaskDimensionsAndMetrics from '@/components/task-lists/TaskDimensionsAndMetrics'
import TaskDetail from '@/components/task-lists/TaskDetail'
import moment from 'moment'
export default {
  components: {
    TaskComments,
    TaskDetail,
    TaskDimensionsAndMetrics
  },
  name: 'TaskCardDisplay',
  props: {
    task: Object,
    showTime: {
      default: true,
      type: Boolean
    }
  },
  data() {
    return {
      expandItem: false
    }
  },
  methods: {
    convertDate(date) {
      if (!date) return 'Not Set'
      return this.showTime
        ? moment(date).format('MMM Do YYYY, h:mm:ss a')
        : moment(date).format('MMM Do YYYY')
    },
    numberFormat(param) {
      return parseFloat(param).toLocaleString()
    }
  }
}
</script>

<style scoped></style>
